import React, { memo, MouseEvent } from "react";
import { TableCell, Checkbox, IconButton, Tooltip, Typography } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import AdjustHoursButtons from "../Worklog/AdjustHoursButtons";
import WorklogReportUtils from "../../utils/WorklogReportUtils";
import { MoreVert } from "@mui/icons-material";
import WorkLogReport from "../../models/WorkLogReport";
import { BillingPolicy } from "../../types/BillingPolicy";
import { Token } from "../../theme";

interface ReportTableRowProps {
  instance: WorkLogReport;
  handleMenuClick: (event: MouseEvent<HTMLButtonElement>, instance: WorkLogReport) => void;
  menuAnchor: any;
  selectedDate: Date;
  canEdit: boolean;
  classes: { [key: string]: string };
  renderCell: (instance: WorkLogReport, week: string | number, value: number, i: number) => React.ReactNode;
  worklogReportState: any;
  isSelected: boolean;
  onToggleSelect: (index: number) => void;
}

export const ReportTableRow: React.FC<ReportTableRowProps> = memo(
  ({
    isSelected,
    onToggleSelect,
    instance,
    handleMenuClick,
    menuAnchor,
    selectedDate,
    canEdit,
    classes,
    renderCell,
    worklogReportState,
  }) => {
    return (
      <>
        <TableCell style={{ padding: "0 1rem" }}>
          {instance.memberFullName !== "Total hours" && instance.memberFullName !== "workdays" ? (
            <div style={{ display: "flex", columnGap: "1rem" }}>
              <Checkbox checked={isSelected} onClick={() => onToggleSelect(instance.index)} />
              <IconButton
                style={{ cursor: "pointer", padding: "0" }}
                onClick={(event) => handleMenuClick(event, instance)}
                aria-haspopup="true"
              >
                <MoreVert />
              </IconButton>
              <Tooltip placement="right-end" title={instance.memberExternalRolName || ""}>
                <Link to={WorklogReportUtils.getUrlToWorklog(instance, selectedDate)}>{instance.memberFullName}</Link>
              </Tooltip>
            </div>
          ) : instance.memberFullName !== "workdays" ? (
            <Typography className={classes.totalHours}>{instance.memberFullName}</Typography>
          ) : (
            ""
          )}
        </TableCell>
        <TableCell style={{ padding: "0 !important" }}>{instance.externalHours !== -1 ? instance.externalHours : ""}</TableCell>
        <TableCell>{instance.timeOffDays ?? 0}</TableCell>
        {Object.entries(instance.hours as Map<number, number>).map(([week, value], i) => renderCell(instance, week, value, i))}
        <TableCell>{instance.bonusedHours}</TableCell>
        <TableCell>
          <div className={classes.tableCell} style={{ backgroundColor: instance.missingHours! > 0 ? Token.statusDangerBg : undefined }}>
            {instance.missingHours}
            {/* {instance.memberFullName !== 'Total hours' && instance.memberFullName !== 'workdays' && canEdit && (
            <AdjustHoursButtons
              worklogReportState={worklogReportState}
              instance={instance}
              showAdjustHours={!!(instance.missingHours && instance.missingHours > 0)}
            />
          )} */}
          </div>
        </TableCell>
        <TableCell>{BillingPolicy[instance.billingPolicy ?? ""] ?? instance.billingPolicy}</TableCell>
        <TableCell>
          {instance.total !== -1 && instance.shadowPosition ? `${instance.total} (Shadow)` : instance.total !== -1 ? instance.total : ""}
        </TableCell>
        {instance.memberFullName !== "Total hours" && instance.memberFullName !== "workdays" && (
          <TableCell key={`WORKLOG_REPORT_TOTAL_APPROVED_${instance.assignationExternalId}_${instance.userExternalId}`}>
            <Checkbox
              disabled
              checked={Object.values(instance.validated as Map<number, boolean>).every((validated) => validated === true)}
            />
          </TableCell>
        )}
      </>
    );
  },
  (prevProps, nextProps) => {
    return prevProps.isSelected === nextProps.isSelected && prevProps.instance === nextProps.instance;
  },
);
